import "./App.css";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import routes from "./routes";
import { Container, Row, Col } from "react-bootstrap";
import Login from "./pages/login/Login";
import { MainContext } from "./contexts/MainContext";
import apiUrl from "./utils/ApiConfig";
import ApiGetX2 from "./utils/ApiServicesX/ApiGetX2";
export default function App() {
  const location = useLocation();
  const navigat = useNavigate();
  let router = useRoutes(routes);

  const [flagThem, setFlagThem] = useState(false);
  const [flag, setFlag] = useState(false);
  const [flag2, setFlag2] = useState(false);
  const [secondSelectDisabled, setSecondSelectDisabled] = useState(true);
  const [user, setUser] = useState(false);
  const [userId, setUserId] = useState("");
  const [lotNameCon, setLotNameCon] = useState("");
  const [titleIdCon, setTitleIdCon] = useState("");
  const [questionIdCon, setQuestionIdCon] = useState("");
  const [XallShaps, setXAllShaps] = useState([]);
  const [vlue16, setValue16] = useState(""); /// کد 16رقمی اصلی
  const [zayech, setZayech] = useState([]); ////مربوط به دایره اصلی
  const [zayechB, setZayechB] = useState([]); //// مربوط به دایره دوم  یا شکل در بطن
  const [zayechC, setZayechC] = useState([]); /// مربوط به دایره سوم در صفحه ramlCircle
  const [titleTopics, setTitleTopics] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [allSource, setAllSource] = useState([]);
  const [dateZayeche, setDateZayeche] = useState("");
  const [batnName, setBatnName] = useState(""); ///نامگذاری دوایر شاهدو طالع و دوایر رسم شده توسط ادمین
  const [allUserShaps, setAllUserShaps] = useState([]); ///زاییچه های ذخیره شده کاربر
  const [ismyZayeheh, setIsMyZayeheh] = useState(false); ///نمایش مدال مای زاییچه آری یا خیر
  const [allShaps, setAllShaps] = useState([]); ///مجموعه 16شکل برای رسم شکل اصلی در درختواره
  const [experience, setExperience] = useState('')
  const [result, setResult] = useState('')
  const [UserShapeId, setUserShapId] = useState('')  ///آیدی زاییچه مشتری

  const imageRef = useRef();
  const imageSpan1 = useRef();
  const imageElement = useRef(null);

  const getAllShapes = () => {
    async function myApp() {
      const res = await fetch(`${apiUrl}/api/AgMain/getShapes`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          console.log(res);
          if (res.ok)
            res.json().then((result) => {
              setXAllShaps(result);
            });
        })
        .catch((err) => console.log(err));
    }
    myApp();
  };

  const refreshToken = () => {
    async function myApp() {
      const res = await fetch(`${apiUrl}/api/User/refreshToken`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.ok) {
            setUser(true);
            getAllShapes();
            return res.json().then((result) => {
              setUserId(result.userId);
            });
          } else {
            setUser(false);
            navigat("/");
          }
        })
        .catch((err) => {
          setUser(false);
        });
    }
    myApp();
  };
  const intervalId = () => {
    setInterval(() => {
      refreshToken();
    }, 600000);
  };
  ///first user authorization  and refreshToken check token  until proje is run
  useEffect(() => {
    if (!location.pathname.includes("signup")) {
      refreshToken();
      intervalId();
      clearInterval(intervalId);
    }
  }, [user]);

  useEffect(() => {
    if (userId) {
      ///گرفتن همه عناوین
      ApiGetX2("/api/AgTopics/getTopic?type=1", setTitleTopics);

      ///گرفتن همه سوالات
      ApiGetX2(`/api/AgTopics/getQuestion`, setAllQuestions);

      ///گرفتن همه زاییچه های کاربر
      const url = `/api/AgMain/getUserShapeByUserID?userId=${userId}`;
      ApiGetX2(url, setAllUserShaps);

      navigat("/selection");
    }
  }, [userId]);

  return (
    <>
      <Container className="App" fluid>
        <MainContext.Provider
          value={{
            flagThem,
            setFlagThem,
            flag,
            setFlag,
            imageRef,
            imageSpan1,
            imageElement,
            secondSelectDisabled,
            setSecondSelectDisabled,
            flag2,
            setFlag2,
            user,
            setUser,
            userId,
            setUserId,
            lotNameCon,
            setLotNameCon,
            titleIdCon,
            setTitleIdCon,
            questionIdCon,
            setQuestionIdCon,
            XallShaps,
            setXAllShaps,
            vlue16,
            setValue16,
            zayech,
            setZayech,
            zayechB,
            setZayechB,
            zayechC,
            setZayechC,
            titleTopics,
            setTitleTopics,
            allQuestions,
            setAllQuestions,
            dateZayeche,
            setDateZayeche,
            allSource,
            setAllSource,
            batnName,
            setBatnName,
            allUserShaps,
            setAllUserShaps,
            ismyZayeheh,
            setIsMyZayeheh,
            allShaps,
            setAllShaps,
            experience, setExperience,
            result, setResult,
            UserShapeId, setUserShapId
          }}
        >
          {router}
        </MainContext.Provider>
      </Container>
    </>
  );
}
